import '../../../src/styles/globals.scss';
import React, {useEffect, useState} from "react";
// @ts-ignore
import InputMask from 'react-input-mask';
/*import C2CService from '../../../services/c2c';*/
import {useForm} from "react-hook-form";
import PulPalLoader from "../PulPalLoader/PulPalLoader";
import {useSelector} from "react-redux";
import C2CService from "../../services/c2c";
import {useNavigate} from "react-router-dom";
import {t} from 'i18next'
import {useTranslation} from "react-i18next";

export const C2CPage = () => {
    const [loadingNotTransparent, setLoadingNotTransparent] = useState<boolean>(false);
    const {language} = useSelector((state: any) => state.languageReducer);
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();
    window.scrollTo({ top: 0, behavior: 'smooth' });

    const {
        control,
        register,
        handleSubmit,
        setError,
        formState: {errors},
    }: any = useForm({mode: "all"});

    const [c2cOptions, setC2cOptions] = useState({
        phone: '',
        c2cNumber: '',
        c2cDate: '',
        cvv: '',
        c2cNumberT: '',
        valuta: 'AZN',
        amount: '',
    });
    const getIpAddress = async () => {
        const res = await fetch("https://api.ipify.org?format=json");
        const data = await res.json();
        return data.ip; // → "123.123.123.123"
    };
    const collectBrowserInfo = async () => {
        const ip = await getIpAddress();

        return {
            browserIp: ip,
            browserScreenHeight: window.screen.height.toString(),
            browserScreenWidth: window.screen.width.toString(),
            browserTZ: Intl.DateTimeFormat().resolvedOptions().timeZone,
        };
    };

    useEffect(() => {
        const raw = sessionStorage.getItem("transfer");
        const data = raw ? JSON.parse(raw) : null;

        if (data) {
            setC2cOptions(prev => ({
                ...prev,
                phone: data.phone,
                amount: data.amount,
            }));
        } else {
            console.log("Yoxdur");
        }
    }, []);

    /*{
      "amount": 10,
      "currency": "azn",

      "description": "test pulpal",

      "country": "az",
      "browser": {
        "browserIp": "192.168.1.1",
        "browserScreenHeight": "1920",
        "browserScreenWidth": "1080",
        "browserTZ": "4",
        "mobilePhone": {
          "cc": "+994",
          "subscriber": "553633633"
        }
      },

      "email": "baliyevfarid@gmail.com",

      "receiverCard": "4127211288561627",
      "beneficiarCard": {
        "holderName": "John",

        "cardNumber": "5490274109490026",
        "expireYear": "2027",
        "expireMonth": "12",
        "cvv": "838",

        "cvvRc": "1"
      }
    }*/

    // @ts-ignore
    const [decoded, setDecoded] = useState<string | undefined>(undefined);
    const onSubmit = async (data: any) => {
        setLoadingNotTransparent(true);
        try {
            let collectBrowser = await collectBrowserInfo();
            const [month, year] = c2cOptions.c2cDate.split("/");

            let resData = {
                amount: Number(c2cOptions.amount),
                currency: c2cOptions.valuta,
                country: language,
                email: "",
                description: "text@pulpal.az",
                browser: {
                    browserIp: collectBrowser.browserIp,
                    browserScreenHeight: collectBrowser.browserScreenHeight,
                    browserScreenWidth: collectBrowser.browserScreenWidth,
                    browserTZ: '4',
                    mobilePhone: {
                        cc: "+994",
                        subscriber: c2cOptions.phone.replace(/\s/g, "")
                    }
                },
                receiverCard: c2cOptions.c2cNumber.replace(/\s/g, ""),
                beneficiarCard: {
                    holderName: "",
                    cardNumber: c2cOptions.c2cNumberT.replace(/\s/g, ""),
                    expireYear: `20${year}`,
                    expireMonth: month,
                    cvv: c2cOptions.cvv,
                    cvvRc: "1"
                }
            };

            let res: any = await C2CService.c2cTransfer(resData);

            if (res.data?.limitCheck === false) {
                const modalEl = document.getElementById('limitModal');
                // @ts-ignore
                const modal = new window.bootstrap.Modal(modalEl);
                modal.show();
                return;
            }

            if (res.data?.htmlResponse) {
                const blob = new Blob([atob(res.data.htmlResponse)], { type: "text/html" });
                const blobUrl = URL.createObjectURL(blob);
                setDecoded(blobUrl);
                window.location.href = blobUrl;
                return;
            }

            if (res.data?.finalResponse) {
                navigate(`/receipt/${res.data?.orderId}`);
            }

        } catch (error) {
            console.error("Transfer error:", error);
        } finally {
            setLoadingNotTransparent(false);
        }
    };

   /* const onSubmit = async (data: any) => {
        setLoadingNotTransparent(true);
        let collectBrowser = await collectBrowserInfo();
        const [month, year] = c2cOptions.c2cDate.split("/");

        let resData = {
            amount: Number(c2cOptions.amount),
            currency: c2cOptions.valuta,
            country: language,
            email: "",
            description: "text@pulpal.az",
            browser: {
                browserIp: collectBrowser.browserIp,
                browserScreenHeight: collectBrowser.browserScreenHeight,
                browserScreenWidth: collectBrowser.browserScreenWidth,
                browserTZ: '4',
                mobilePhone: {
                    cc: "+994",
                    subscriber: c2cOptions.phone.replace(/\s/g, "")
                }
            },
            receiverCard: c2cOptions.c2cNumber.replace(/\s/g, ""),
            beneficiarCard: {
                holderName: "",
                cardNumber: c2cOptions.c2cNumberT.replace(/\s/g, ""),
                expireYear: `20${year}`,
                expireMonth: month,
                cvv: c2cOptions.cvv,
                cvvRc: "1"
            }
        };

        let res: any = await C2CService.c2cTransfer(resData);

        if (res.data && res.data.htmlResponse) {
            const decodedHtml = atob(res.data.htmlResponse);

            const blob = new Blob([decodedHtml], {type: "text/html"});
            const blobUrl = URL.createObjectURL(blob);

            setDecoded(blobUrl);

            setLoadingNotTransparent(false);

            //if(blobUrl) window.location.href = blobUrl
            window.open(blobUrl, "_blank");
        } else {
            setLoadingNotTransparent(false);
        }

    };*/

    return (
        <div className="container">

            <div className="mt-5 pt-5">
                <div className="fw-bold fs-3">{t("cardToCardTransfer")} </div>
                <p className="text-muted mb-4">
                    {t("enterCardDetails")}
                </p>
            </div>


            <form onSubmit={handleSubmit(onSubmit)} className="my-5 p-5 rounded-20 shadow">
                <div className="row justify-content-center">

                    <div className="col-12 col-md-5">
                        <div className="fs-4">{t("fromCard")}</div>
                        <hr/>
                        <div className="mb-3">
                            <label className="form-label">{t("phoneNumber")}</label>
                            <InputMask type="tel" mask="99 999 99 99" autoComplete="on"
                                       placeholder="99 999 99 99" value={c2cOptions.phone}
                                       className={`form-control ${errors.phone ? "inputsSpecial errorInputs" : ""}`}
                                       {...register("phone", {
                                           required: true,
                                           minLength: {value: 12, message: "Tam 9 rəqəm daxil edin"},
                                           maxLength: {value: 12, message: "Tam 9 rəqəm daxil edin"},
                                           pattern: {
                                               value: /^(?!.*_)(\d{2} \d{3} \d{2} \d{2})$/,
                                               message: "Nömrəni tam daxil edin"
                                           }
                                       })}
                                       onChange={(e: any) => {
                                           setC2cOptions({
                                               ...c2cOptions,
                                               phone: e.target.value,
                                           });
                                       }}/>
                        </div>
                        <div className="p-4 rounded border bg-white ">

                            <div className="mb-3">
                                <label className="form-label">{t("cardNumber")}</label>
                                <InputMask mask="9999 9999 9999 9999" type="text" autoComplete="on"
                                           placeholder="•••• •••• •••• ••••" value={c2cOptions.c2cNumberT}
                                           className={`form-control ${errors.c2cNumberT ? "inputsSpecial errorInputs" : ""}`}
                                           {...register("c2cNumberT", {
                                               required: true,
                                               pattern: {
                                                   value: /^(?!.*_)(\d{4} \d{4} \d{4} \d{4})$/,
                                                   message: "Tam 16 rəqəm daxil edin"
                                               },
                                               min: {
                                                   value: 18,
                                                   message: "16 rəqəmli kod"
                                               },
                                               max: {
                                                   value: 19,
                                                   message: "16 rəqəmli kod"
                                               },
                                           })}
                                           onChange={(e: any) => {
                                               setC2cOptions({
                                                   ...c2cOptions,
                                                   c2cNumberT: e.target.value,
                                               });
                                           }}/>
                            </div>

                            <div className="row">
                                <div className="col-md-6 mb-3">
                                    <label className="form-label">{t("expirationDate")}</label>
                                    <InputMask mask="99/99" placeholder="MM/YY"
                                               value={c2cOptions.c2cDate}
                                               className={`form-control ${errors.c2cDate ? "inputsSpecial errorInputs" : ""}`}
                                               {...register("c2cDate", {
                                                   required: true,
                                                   pattern: {
                                                       value: /^(?!.*_)(0[1-9]|1[0-2])\/\d{2}$/,
                                                       message: "Tarix formatı düzgün deyil"
                                                   }
                                               })}
                                               onChange={(e: any) => {
                                                   setC2cOptions({
                                                       ...c2cOptions,
                                                       c2cDate: e.target.value,
                                                   });
                                               }}/>
                                </div>
                                <div className="col-md-6 mb-3">
                                    <label className="form-label">CVV</label>
                                    <InputMask mask="999" placeholder="***"
                                               value={c2cOptions.cvv}
                                               className={`form-control ${errors.cvv ? "inputsSpecial errorInputs" : ""}`}
                                               {...register("cvv", {
                                                   required: true,
                                               })}
                                               onChange={(e: any) => {
                                                   setC2cOptions({
                                                       ...c2cOptions,
                                                       cvv: e.target.value,
                                                   });
                                               }}/>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-2">
                        <div className="d-flex justify-content-center align-items-center h-100">
                            <div className="border-left font-30 text-muted">
                                ➔
                            </div>
                        </div>
                    </div>

                    <div className="col-12 col-md-5">

                        <div className="fs-4">{t("toCard")}</div>
                        <hr/>


                        <div className="mb-3">
                            <label className="form-label">{t("toCard")}</label>
                            <InputMask mask="9999 9999 9999 9999" autoComplete="on"
                                       placeholder="•••• •••• •••• ••••" value={c2cOptions.c2cNumber}
                                       className={`form-control ${errors.c2cNumber ? "inputsSpecial errorInputs" : ""}`}
                                       {...register("c2cNumber", {
                                           required: true,
                                           pattern: {
                                               value: /^(?!.*_)(\d{4} \d{4} \d{4} \d{4})$/,
                                               message: "Tam 16 rəqəm daxil edin"
                                           },
                                       })}
                                       onChange={(e: any) => {
                                           setC2cOptions({
                                               ...c2cOptions,
                                               c2cNumber: e.target.value,
                                           });
                                       }}/>
                        </div>

                        <div className="mb-3">
                            <label className="form-label fw-bold">{t("transferAmount")}</label>

                            <div className="input-group">
                                <input
                                    type="number"
                                    placeholder={t("enterAmount")}
                                    min="1"
                                    max="4000" value={c2cOptions.amount}
                                    step="any"
                                    className={`form-control ${errors.amount ? "inputsSpecial errorInputs" : ""}`}
                                    {...register("amount", {
                                        required: true,
                                    })}
                                    onChange={(e: any) => {
                                        setC2cOptions({
                                            ...c2cOptions,
                                            amount: e.target.value,
                                        });
                                    }}
                                />
                                <select style={{maxWidth: "100px"}}
                                        value={c2cOptions.valuta}
                                        onSelect={"AZN"}
                                        className={`form-control form-select-sm ${errors.valuta ? "inputsSpecial errorInputs" : ""}`}
                                        {...register("valuta", {
                                            required: true,
                                        })}
                                        onChange={(e: any) => {
                                            setC2cOptions({
                                                ...c2cOptions,
                                                valuta: e.target.value,
                                            });
                                        }}>
                                    <option value="AZN">AZN</option>
                                    <option value="USD">USD</option>
                                    <option value="EUR">EUR</option>
                                </select>
                            </div>

                            <div className="form-text mt-1">{t("amountLimits")}</div>
                        </div>

                        <div className="alert alert-warning rounded-4 mt-3 center"
                             style={{backgroundColor: "#FFF8E5", color: "#4b4b4b", border: "none"}}>
                            {t("cardToCardTransfers")}
                        </div>

                        <hr/>
                        <div className="d-flex justify-content-between align-items-center">
                            <span className="fw-bold">{t("amount")}</span>
                            <span className="fw-bold text-info fs-5">{c2cOptions.amount} ₼</span>
                        </div>
                    </div>

                    <div className="alert alert-warning rounded-4 mt-3 center"
                         style={{backgroundColor: "#FFF8E5", color: "#4b4b4b", border: "none"}}>
                        {t("commissionNote")}
                    </div>

                    <div className="col-12">
                        <div className="d-flex justify-content-between mt-4">
                            <button className="btn btn-outline-secondary">{t("goBack")}</button>
                            <button className="btn btn-info text-white" type="submit">{t("TRANSFER")}</button>
                        </div>
                    </div>

                </div>
            </form>

            <div className="modal fade" id="limitModal" tabIndex={-1} aria-labelledby="limitModalLabel"
                 aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="limitModalLabel">Əməliyyat limiti</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal"
                                    aria-label="Bağla"></button>
                        </div>
                        <div className="modal-body">
                            {t("YouHaveExceededYourDailyTransactionLimit")}
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-primary" data-bs-dismiss="modal">Bağla</button>
                        </div>
                    </div>
                </div>
            </div>


            {loadingNotTransparent && (
                <div
                    className={`pulpal-loader-wrapper ${loadingNotTransparent ? 'pulpal-loader-wrapper--not-transparent' : ''} `}>
                    <PulPalLoader/>
                </div>
            )}

        </div>
    )
}
